
const us = {
  AL: {code: 'AL', country: 'US', name: 'Alabama'},
  AK: {code: 'AK', country: 'US', name: 'Alaska'},
  AS: {code: 'AS', country: 'US', name: 'American Samoa'},
  AZ: {code: 'AZ', country: 'US', name: 'Arizona'},
  AR: {code: 'AR', country: 'US', name: 'Arkansas'},
  CA: {code: 'CA', country: 'US', name: 'California'},
  CO: {code: 'CO', country: 'US', name: 'Colorado'},
  CT: {code: 'CT', country: 'US', name: 'Connecticut'},
  DE: {code: 'DE', country: 'US', name: 'Delaware'},
  DC: {code: 'DC', country: 'US', name: 'District of Columbia'},
  FL: {code: 'FL', country: 'US', name: 'Florida'},
  GA: {code: 'GA', country: 'US', name: 'Georgia'},
  GU: {code: 'GU', country: 'US', name: 'Guam'},
  HI: {code: 'HI', country: 'US', name: 'Hawaii'},
  ID: {code: 'ID', country: 'US', name: 'Idaho'},
  IL: {code: 'IL', country: 'US', name: 'Illinois'},
  IN: {code: 'IN', country: 'US', name: 'Indiana'},
  IA: {code: 'IA', country: 'US', name: 'Iowa'},
  KS: {code: 'KS', country: 'US', name: 'Kansas'},
  KY: {code: 'KY', country: 'US', name: 'Kentucky'},
  LA: {code: 'LA', country: 'US', name: 'Louisiana'},
  ME: {code: 'ME', country: 'US', name: 'Maine'},
  MD: {code: 'MD', country: 'US', name: 'Maryland'},
  MA: {code: 'MA', country: 'US', name: 'Massachusetts'},
  MI: {code: 'MI', country: 'US', name: 'Michigan'},
  MN: {code: 'MN', country: 'US', name: 'Minnesota'},
  MS: {code: 'MS', country: 'US', name: 'Mississippi'},
  MO: {code: 'MO', country: 'US', name: 'Missouri'},
  MT: {code: 'MT', country: 'US', name: 'Montana'},
  NE: {code: 'NE', country: 'US', name: 'Nebraska'},
  NV: {code: 'NV', country: 'US', name: 'Nevada'},
  NH: {code: 'NH', country: 'US', name: 'New Hampshire'},
  NJ: {code: 'NJ', country: 'US', name: 'New Jersey'},
  NM: {code: 'NM', country: 'US', name: 'New Mexico'},
  NY: {code: 'NY', country: 'US', name: 'New York'},
  NC: {code: 'NC', country: 'US', name: 'North Carolina'},
  ND: {code: 'ND', country: 'US', name: 'North Dakota'},
  MP: {code: 'MP', country: 'US', name: 'Northern Mariana Islands'},
  OH: {code: 'OH', country: 'US', name: 'Ohio'},
  OK: {code: 'OK', country: 'US', name: 'Oklahoma'},
  OR: {code: 'OR', country: 'US', name: 'Oregon'},
  PA: {code: 'PA', country: 'US', name: 'Pennsylvania'},
  PR: {code: 'PR', country: 'US', name: 'Puerto Rico'},
  RI: {code: 'RI', country: 'US', name: 'Rhode Island'},
  SC: {code: 'SC', country: 'US', name: 'South Carolina'},
  SD: {code: 'SD', country: 'US', name: 'South Dakota'},
  TN: {code: 'TN', country: 'US', name: 'Tennessee'},
  TX: {code: 'TX', country: 'US', name: 'Texas'},
  UM: {code: 'UM', country: 'US', name: 'Minor Outlying Islands'},
  UT: {code: 'UT', country: 'US', name: 'Utah'},
  VT: {code: 'VT', country: 'US', name: 'Vermont'},
  VI: {code: 'VI', country: 'US', name: 'Virgin Islands'},
  VA: {code: 'VA', country: 'US', name: 'Virginia'},
  WA: {code: 'WA', country: 'US', name: 'Washington'},
  WV: {code: 'WV', country: 'US', name: 'West Virginia'},
  WI: {code: 'WI', country: 'US', name: 'Wisconsin'},
  WY: {code: 'WY', country: 'US', name: 'Wyoming'},
};

const ca = {
  AB: {code: 'AB', country: 'CA', name: 'Alberta'},
  BC: {code: 'BC', country: 'CA', name: 'British Columbia'},
  MB: {code: 'MB', country: 'CA', name: 'Manitoba'},
  NB: {code: 'NB', country: 'CA', name: 'New Brunswick'},
  NL: {code: 'NL', country: 'CA', name: 'Newfoundland and Labrador'},
  NT: {code: 'NT', country: 'CA', name: 'Northwest Territories'},
  NS: {code: 'NS', country: 'CA', name: 'Nova Scotia'},
  NU: {code: 'NU', country: 'CA', name: 'Nunavut'},
  ON: {code: 'ON', country: 'CA', name: 'Ontario'},
  PE: {code: 'PE', country: 'CA', name: 'Prince Edward Island'},
  QC: {code: 'QC', country: 'CA', name: 'Quebec'},
  SK: {code: 'SK', country: 'CA', name: 'Saskatchewan'},
  YT: {code: 'YT', country: 'CA', name: 'Yukon'},
};

const all = {...us, ...ca};

export default {us, ca, all};

